/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Spinner,
  SvgIcon,
  Badge
} from '../'

export const SelectBadges = (props) => {
  let id = props.id
    ? props.id
    : Math.floor(Math.random() * 1000)

  return (
    <div className={`slds-form-element${props.hasError ? ' slds-has-error' : ''} ${props.className ? props.className : ''}`}>
      {props.label &&
        <label
          className='slds-form-element__label'
          htmlFor={id}>
          {props.label}
        </label>
      }
      <div className='slds-form-element__control'>
        <div className='slds-grid slds-wrap'>
          {props.options.map(option => (
              <Badge
                selected={props.value === option.value}
                inverse={true}
                onClick={() => props.onChange(option.value)}
                className='slds-m-around_xx-small'
                key={`badge_${option.label}`}>
                {option.label}
              </Badge>
            ))}
        </div>
      </div>
    </div>
  )
}

SelectBadges.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string
    })),
    PropTypes.arrayOf(PropTypes.string)
  ]).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  hasError: PropTypes.bool,
  inline: PropTypes.bool,
  className: PropTypes.string
}

const SelectBadgesData = (props) => {
  if (props.data.loading) {
    return <Spinner className='slds-is-relative' size='x-small' />
  }

  if (props.data.error) {
    return (
      <SvgIcon
        variant='utility'
        symbol='warning'
        colour='error'
        size='x-small'
        title={`Error loading required options for ${this.props.forField}`}
      />
    )
  }

  let id = props.id
  ? props.id
  : `selectBadges_${Math.floor(Math.random() * 1000)}`

  return (
    <SelectBadges
      id={id}
      options={props.data.__type.enumValues.map(option => (
        {
          value: option.name.toLowerCase(), label: option.description
        }
      ))}
      disabled={props.disabled}
      value={props.value
        ? props.value.toLowerCase()
        : props.placeholder ? props.placeholder : undefined
      }
      onChange={props.onChange}
    />
  )
}

SelectBadgesData.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  forField: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  hasError: PropTypes.bool,
  inline: PropTypes.bool,
  className: PropTypes.string
}

export const getOptions = gql`
  query($name: String!) {
    __type(name: $name) {
      name
      kind
      enumValues {
        name
        description
      }
    }
  }
`

export const withData =
  graphql(getOptions, {
    options: (ownProps) => ({
      variables: {
        name: ownProps.forField
      }
    })
  })

export default withData(SelectBadgesData)



// WEBPACK FOOTER //
// ./src/components/select-badges/index.js